import { Button, Col, Row, Input, DatePicker } from "antd";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import SelectStatus from "../../../components/SelectStatus";
import UserManualButton from "../../../components/UserManualButton";
const { Search } = Input;

const FilterMenu = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const onSearch = (value) => props.onSearch(value);
  const onClear = (value) => props.onClear(value);

  const handleNavigate = () => {
    navigate(`/request-outbound/add`);
  };

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <>
      <Row
        align="top"
        style={{ marginBottom: "18px" }}
        justify={"space-between"}
        gutter={[8, 8]}
      >
        <Col lg={16} xs={24}>
          <Row gutter={[8, 8]} align={"middle"}>
            <Col lg={6} md={6} sm={12} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2 }}>Tanggal Request</p>
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  placeholder="Pilih Tanggal"
                />
              </>
            </Col>
            <Col lg={6} md={6} sm={12} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2 }}>Tanggal Masuk</p>
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  placeholder="Pilih Tanggal"
                />
              </>
            </Col>
            <Col lg={6} md={6} sm={12} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2 }}>Status</p>
                <SelectStatus
                  value={searchParams.get("status") || null}
                  onChange={(e) => updateSearchParam("status", e || null)}
                />
              </>
            </Col>
            <Col lg={3} md={4} sm={5} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                  Clear Filter
                </p>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <Button
                    style={{ width: "100%" }}
                    onClick={() => {
                      setSearchParams({});
                    }}
                  >
                    Clear Filter
                  </Button>
                  <UserManualButton />
                </div>
              </>
            </Col>
          </Row>
        </Col>
        <Col lg={8} xs={24}>
          <Row gutter={[8, 8]} align={"middle"} justify={"end"}>
            <Col xl={12} lg={14} md={6} sm={8} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                  Search
                </p>
                <Search
                  placeholder="Input Jenis Produk"
                  allowClear
                  defaultValue={searchParams.get("search") || null}
                  onSearch={onSearch}
                  style={{ width: "100%" }}
                  onClear={onClear}
                />
              </>
            </Col>
            <Col xl={9} lg={9} md={4} sm={6} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                  Request Outbound
                </p>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  onClick={() => handleNavigate()}
                >
                  Request Outbound
                </Button>
              </>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default FilterMenu;
